import type { AnybillResult } from "~/additionalModels/AnybillResponse";
import type CurrentPricingOverviewDto from "~/models/CurrentPricingOverviewDto";
import type StandardPricingPackageDto from "~/models/StandardPricingPackageDto";
import { PricingProvider } from "~/provider/PricingProvider";

export const usePricingModule = defineStore("pricing", () => {
  const pricingOverview = ref<CurrentPricingOverviewDto | null>(null);
  const loading = ref(false);
  const initialized = ref(false);

  async function populate() {
    loading.value = true;
    const result = await useTypedFetch<AnybillResult<CurrentPricingOverviewDto>>(
      "/pricingReferenceStandardService/get",
    );

    loading.value = false;
    if (result.success) {
      pricingOverview.value = result.value;

      // Transform packages array to object indexed by packageType for custom pricing
      if (pricingOverview.value?.customerId && Array.isArray(pricingOverview.value?.packages)) {
        const packagesObj: any = {};
        pricingOverview.value.packages.forEach((pkg) => {
          packagesObj[pkg.packageType] = pkg;
        });
        pricingOverview.value.packages = packagesObj;
      }

      initialized.value = true;
    }
    else {
      // ErrorHandler.Instance.handleAxiosError(result.errorMessage, "PricingStore");
      initialized.value = false;
    }
  }

  async function getPricingById(id: string): Promise<StandardPricingPackageDto | undefined> {
    const result = await PricingProvider.instance.getPricingById(id);
    if (result.success) {
      return result.value;
    }
  }

  return { populate, getPricingById, pricingOverview, loading, initialized };
});
